



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { PreventivaNuevo } from '@/pantallas/Preventivas/Preventiva';
import DetallePreventivaForm from '@/pantallas/HistoricoMantenimiento/DetallePreventivaForm.vue';
import { HistoricosPreventivoList } from '@/pantallas/HistoricoMantenimiento/fetchHistoricoPreventivo';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    DetallePreventivaForm,
  },
})
export default class VerDetallePlanPreventivoModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true }) planSeleccionado: HistoricosPreventivoList;

  pasoActivoIndex = 1;
  pasos = {
    mantenimientoPreventivo: {
      accion: 'Ver Detalle - Mantenimiento Preventivo',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;

  /* misc */

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  /* event handlers */

  handleCerrar() {
    this.$emit('cerrar');
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }

  @Watch('planSeleccionado', { deep: true, immediate: true })
  async handlePlanSeleccionadoChange() {
    if (!this.planSeleccionado) {
      return;
    }
  }
}
